import { createSelector } from 'reselect'

import { selectComposedReportState } from './selectComposedReportState'

export const selectOpenedFilterData = createSelector(
  [selectComposedReportState],
  ({ openedFilterData }) => openedFilterData
)
